<template>
  <div>
    <viewTable
        ref="viewTable"
        :limits="limits"
        :columns-property="columnsProperty"
        :filter="filter"
        module="basic"
        url="productonAssembles"
        :table-action="true"
        @delete="deleteHandle"
        @select="selectHandle"
        @reset="resetHandle"
        @addOrEdit="addEditHandle">
      <template slot="otherBtn">
      </template>
      <template slot="adSearch">
        <el-form :inline="true" :model="filter" @keyup.enter.native="loadData(1)">
          <el-form-item label="是否完工" prop="isEnd">
            <el-select v-model="filter.isEnd" clearable>
              <el-option label="否" :value="0"/>
              <el-option label="是" :value="1"/>
            </el-select>
          </el-form-item>
          <el-form-item label="生产订单号" prop="productionNo">
            <el-input v-model="filter.productionNo" clearable/>
          </el-form-item>
          <el-form-item label="工序" prop="station">
            <el-input v-model="filter.station" clearable/>
          </el-form-item>
        </el-form>
      </template>
    </viewTable>
    <production-assemble-edit
        :visible.sync="editVisible"
        :data="editData"
        @submit="submitHandle"
    />
  </div>
</template>

<script>
  import viewTable from "@/components/ViewTable.vue";
  import ProductionAssembleEdit from "./ProductionAssembleEdit.vue";

  export default {
    name: "ProductionAssembleList",
    components: { viewTable, ProductionAssembleEdit },
    data() {
      return {
        limits: {
          addAuth: this.$auth(749),
          editAuth: this.$auth(750),
          delAuth: this.$auth(751),
        },
        filter: {
          isEnd: '',
          productionNo: '',
          station: '',
        },
        selection: [],
        editVisible: false,
        editData: {},
        columnsProperty: [
          {
          tooltip: true, key: "assembleStartQty", width: 160, align: "center" },
          {
          tooltip: true, key: "assembleStationQty", width: 160, align: "center" },
          {
          tooltip: true, key: "completeQty", width: 160, align: "center" },
          {
          tooltip: true, key: "assembleLineName", width: 160, align: "center" },
          {
          tooltip: true, key: "station", width: 160, align: "center" },
          {
          tooltip: true, key: "productionNo", width: 160, align: "center" },
          {
          tooltip: true, key: "isEnd", width: 100, align: "center" },
          { key: "action", width: 150, align: "center", slot: "action" },
        ],
      };
    },
    mounted() {
    },
    methods: {
      selectHandle(selection) {
        this.selection = selection;
      },
      loadData(pageNum) {
        this.$refs.viewTable.loadData(pageNum);
      },
      deleteHandle(row) {
        this.$http.delete("basic", "productonAssembles", row.pkId).then((resp) => {
          if (resp.success) {
            this.loadData();
            this.$message.success("删除成功");
          }
        });
      },
      resetHandle(filter) {
        this.filter = filter;
      },
      addEditHandle(row) {
        this.editData = row || {};
        this.editVisible = true;
      },
      submitHandle(form) {
        if (form.pkId) {
          // 编辑
          this.$http.put("basic", "productonAssembles", form).then((resp) => {
            if (resp.success) {
              this.editVisible = false;
              this.loadData();
              this.$message.success("编辑成功");
            }
          });
        } else {
          // 新增
          this.$http.post("basic", "productonAssembles", form).then((resp) => {
            if (resp.success) {
              this.editVisible = false;
              this.loadData();
              this.$message.success("新增成功");
            }
          });
        }
      },
    },
  };
</script>